import { FeatureConfiguration } from "..";
import { reducer } from "./reducers";

export * from "./reducers";

export default function (config: FeatureConfiguration) {
    config.reducers.notifications = reducer;
}
